import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "editor", "format"]

  connect() {
    this.editorTarget.innerHTML = this.inputTarget.value || ""
    this.refresh()
  }

  sync() {
    this.inputTarget.value = this.editorTarget.innerHTML.trim()
    this.refresh()
  }

  command(event) {
    event.preventDefault()
    const command = event.currentTarget.dataset.command
    const value = event.currentTarget.dataset.value || null

    if (command === "createLink") {
      this.createLink()
      return
    }

    document.execCommand(command, false, value)
    this.editorTarget.focus()
    this.sync()
  }

  block(event) {
    event.preventDefault()
    document.execCommand("formatBlock", false, event.currentTarget.dataset.value)
    this.editorTarget.focus()
    this.sync()
  }

  createLink() {
    const url = window.prompt("URL")
    if (!url) return

    document.execCommand("createLink", false, url)
    this.editorTarget.focus()
    this.sync()
  }

  refresh() {
    if (!this.hasFormatTarget) return

    this.formatTargets.forEach((button) => {
      const command = button.dataset.command
      if (!command || command === "createLink") return

      button.classList.toggle("is-active", document.queryCommandState(command))
    })
  }
}
